import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vchannel',
  providers: [CommonPipe],
  templateUrl: './vchannel.component.html',
  styleUrls: ['./vchannel.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VchannelComponent implements OnInit {
  application = "";
  component = '';
  compose_response: any = [];
  is_owner = false;
  rate = 0;
  toggler = true;
  currentIndex = 0;
  video_url = {};
  params: any = [];
  action_class: any = {};
  pathToMedia: any = {};
  id = "";
  response: any = [];
  images: any = [];
  report_param: any = [];
  video_loading = false;
  isLogin = false;
  btn_process = false;
  rate_readonly = false;
  page_load = true;
  api: VgApiService;
  video_source: any = [];
  channel_response = [];
  constructor(public ngxSmartModalService: NgxSmartModalService, private _mail: MailService, private router: Router, private _commonPipe: CommonPipe, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {


    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
      this.application = 'video';
      let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
      this.component=pa.c;
      this.id=pa.id;

      let p = {
        'component': this.component,
        'application': 'channel',
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.channel_response = this._global.getVal(data, 'response', '');
            this.is_owner = this._global.isOwner(this._global.getVal(this.channel_response, 'createdBy', ''));
            this.pathToMedia = this._global.getVal(this.channel_response, 'pathToMedia', {});
            let first = true;
            Object.entries(this.pathToMedia).forEach(([key, value]) => {
              this.video_source.push(value);
              if (first) {
                this.video_url = value;
                this.loadMedia(value['uid']);
                first = false;
              }

            });
            Object.entries(this.channel_response['video']).forEach(([key, value]) => {
              value = this._global.asJsonObject(value);
              value['uid']=value['id'];
              let r = {
                mediaType: "video",
                uid: key,
                name: value['name']
              }
              if(first){
                this.video_url = value;
                this.loadMedia(key);
                first = false;
              }
              this.video_source.push(r);
            });
            this._global.addMetaInfo(this.response, 'view','name');
           this.report_param = {
              id: this.response.id,
              name: this.response.name
            };
           
            if( this.video_source.length==0){
              this.video_loading=false;
              this._global.addMetaInfo(this.channel_response, 'view','name');
            }

          }else{
            this.router.navigate(['']);
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
  }
  ngOnInit() {

  }
  edit() {
    this.router.navigate(['/my/video'], { queryParams: { 'channelid': this.id } });
  }
  channelEdit(){
    this.router.navigate(['/edit/channel'], { queryParams: { a:this.application,'id': this.id } });
  }
  videoEdit(){
    this.router.navigate(['/edit/'+this.application], { queryParams: { a:this.application,'id': this.response['id'] } });
  }
  loadMedia(id) {
    this.video_loading = false;
    this.response = {};
    let p = {
      'component': this.component,
      'application': this.application,
      'id': id
    };
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.video_loading = true;
          this.response = this._global.getVal(data, 'response', '');
          this._global.addMetaInfo(this.response, 'view','name');
          this.report_param = {
            id: this.response.id,
            name: this.response.name
          };
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  returnZero() {
    return 0
  }

  gotoVideo(obj, index) {
    this.currentIndex = index;
    this.video_url = obj;
    this.loadMedia(obj['uid']);
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;

    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playVideo.bind(this));
    this.api.getDefaultMedia().subscriptions.ended.subscribe(this.nextVideo.bind(this));
  }

  nextVideo() {
    this.currentIndex++;
    if (this.currentIndex === this.video_source.length) {
      this.currentIndex = 0;
    }

    this.video_url = this.video_source[this.currentIndex];
    this.loadMedia(this.video_url['uid']);
  }

  playVideo() {
    this.api.play();
  }

}
